import { createContext } from "react";

import { SearchState, initialSearchState } from "./state";

export interface SearchContextInterface extends SearchState {
  setShowSuggestions: (show: boolean) => void;
  setQuery: (query: string) => void;
  updateSearch: (query: string) => void;
  setSearchDescription: (title: string, text: string) => void;
}

const stub = (): never => {
  throw new Error("You forgot to wrap your component in <SearchProvider>");
};

const initialContext = {
  ...initialSearchState,
  setShowSuggestions: stub,
  setQuery: stub,
  updateSearch: stub,
  setSearchDescription: stub,
};

export const SearchContext = createContext<SearchContextInterface>(
  initialContext
);
